import FlowHeader from '../../../components/FlowHeader/FlowHeader';
import FooterSite from '../../../components/FooterSite/FooterSite';
import BaseLayout from '../../../components/BaseLayout/BaseLayout';
import InternalAuthenticator from '../../../components/BaseLayout/InternalAuthenticator';
import SummitRewards from '../../../components/BaseLayout/SummitRewards';
import AddressValidationModal from '../../../components/AddressValidationModal/AddressValidationModal';
import CredentialsValidationModal from '../../../components/CredentialsValidationModal/CredentialsValidationModal';
import ContribLimitFailModal from '../../../components/ContribLimitFailModal/ContribLimitFailModal';
import FONASUContribScreen from '../../../screens/FONASUContribScreen/FONASUContribScreen';
import { FlowNode } from '../../../core/types/flow';
import { contactTextFn, updateFONASUAnalytics } from '../../shared/utils';
import { openModal, finish } from '../../../core/actions';
import { ToIRATypes, makeLoadContributoryData } from './loaders';
import { createFONASUApplication } from '../shared/loaders';
import {
  isValidSSN,
  isValidDob,
  usernameValidation,
  contribLimitSvcFail,
  isUsernameAlreadyTaken,
  isUsernameCreationFailed,
  isTempPasswordCreationFailed,
  chosenAddressValidation
} from '../../shared/testers';

export const makeNodes = (toIRATypes: ToIRATypes): Array<FlowNode> => [
  {
    route: 'fonasuContributory',
    screen: FONASUContribScreen,
    load: makeLoadContributoryData(toIRATypes),
    postLoad: {
      cases: [[contribLimitSvcFail, openModal(ContribLimitFailModal)]],
      default: finish()
    },
    commit: createFONASUApplication,
    form: [
      { name: 'fundingOption', required: true },
      { name: 'firstName', required: true },
      { name: 'lastName', required: true },
      { name: 'middleName' },
      { name: 'dob', required: true, validation: isValidDob },
      { name: 'citizenship', required: true },
      { name: 'ssn', required: true, validation: isValidSSN },
      { name: 'residentialStreet1', required: true },
      { name: 'residentialStreet2' },
      { name: 'residentialZip', required: true },
      { name: 'residentialCity', required: true },
      { name: 'residentialState', required: true },
      { name: 'mailingStreet1', required: true },
      { name: 'mailingStreet2' },
      { name: 'mailingZip', required: true },
      { name: 'mailingCity', required: true },
      { name: 'mailingState', required: true },
      { name: 'primaryEmailAddress', required: true },
      { name: 'phone1' },
      { name: 'phone2' },
      { name: 'phone3' },
      { name: 'mailingAddressDifferent', type: 'checkbox' },
      { name: 'useResidentialAddress', required: true },
      { name: 'useMailingAddress', required: true },
      { name: 'amount', required: true },
      { name: 'currentYearAmount' },
      { name: 'priorYearAmount' },
      {
        name: 'username',
        validation: usernameValidation
      },
      {
        name: 'password'
      }
    ],
    next: {
      cases: [
        [chosenAddressValidation, openModal(AddressValidationModal)],
        [isUsernameAlreadyTaken, openModal(CredentialsValidationModal)],
        [isTempPasswordCreationFailed, openModal(CredentialsValidationModal)],
        [isUsernameCreationFailed, openModal(CredentialsValidationModal)]
      ],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'FONASUContributory'
      }
    }
  }
];

export const makeFlow = (path: string, toIRAType: ToIRATypes): any => {
  const nodes = makeNodes(toIRAType);
  return {
    namespace: `front-office/mutual-fund/contributory/${path}`,
    nodes,
    start: 'fonasuContributory',
    pageDecorators: [BaseLayout, InternalAuthenticator, SummitRewards],
    onLoad: updateFONASUAnalytics,
    flowProps: {
      getContactText: contactTextFn(),
      header: FlowHeader,
      footer: FooterSite
    }
  };
};
